import Flex from '../flex-container';

export default {
  name       : 'Row',
  components : {
    Flex
  },
  props   : { items: null },
  methods : {
  }
};
